// import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';
import { LeadTimePerRegions } from '../../models/lead-time.interface';

export enum AdtLeadTimesActionTypes {
  FETCH_LEAD_TIMES = '[ADT Lead Times] Fetch Lead times',
  FETCH_LEAD_TIMES_SUCCESS = '[ADT Lead Times] Fetch Lead times success',
  FETCH_LEAD_TIMES_FAILURE = '[ADT Lead Times] Fetch Lead times failure',
  RESET = '[ADT Lead Times] Reset Lead times',
}

/**
 * Fetch lead times
 */
export class FetchLeadTimesAction implements Action {
  readonly type = AdtLeadTimesActionTypes.FETCH_LEAD_TIMES;

  constructor() {}
}

/**
 * Load success lead times
 */
export class FetchLeadTimesSuccessAction implements Action {
  readonly type = AdtLeadTimesActionTypes.FETCH_LEAD_TIMES_SUCCESS;

  constructor(public payload: LeadTimePerRegions[]) {}
}

/**
 * Load lead times
 */
export class FetchLeadTimesFailureAction implements Action {
  readonly type = AdtLeadTimesActionTypes.FETCH_LEAD_TIMES_FAILURE;

  constructor() {}
}

/**
 * Reset lead times
 */
export class ResetLeadTimesAction implements Action {
  readonly type = AdtLeadTimesActionTypes.RESET;

  constructor() {}
}

export type AdtLeadTimesActions =
  | FetchLeadTimesAction
  | FetchLeadTimesSuccessAction
  | FetchLeadTimesFailureAction
  | ResetLeadTimesAction;
